import AlertComponent from './Alert';

export { type AlertProps, alert } from '@flipster/utils/alert';
export { AlertComponent };
